// extracted by mini-css-extract-plugin
export default {"home":"First_home__lcot+","containerSearchBox":"First_containerSearchBox__NI1gF","Flight":"First_Flight__z4QdV","flat":"First_flat__kQdSH","icon":"First_icon__tFtc7"};